import React from 'react';

import { formatMoney, toMoney } from '@betterment/core';
import { Box, Card, Table, Text } from '@betterment/samba-react';

import { IdempotencyProviderWithFeatureRegistry } from '../../../../providers/IdempotencyProviderWithFeatureRegistry';
import { FeeAttempt } from '../data';

interface ReviewFeesTableProps {
  feeAttempts: FeeAttempt[];
}

const ReviewFeesTable: React.FC<ReviewFeesTableProps> = ({ feeAttempts }) => {
  return (
    <Card
      css={{
        borderStyle: 'solid',
        borderWidth: 'thin',
        borderColor: 'border',
        boxShadow: 'none',
      }}
    >
      <Card.Content css={{ p: '0' }}>
        <Table
          aria-label="feeReviewTable"
          css={{
            bg: 'background.surface',
            overflowX: 'visible',
            tableLayout: 'fixed',
          }}
        >
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeaderCell css={{ width: '35%' }}>Client</Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell css={{ width: '25%' }}>Account</Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell css={{ width: '35%' }}>Fee amount</Table.ColumnHeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <IdempotencyProviderWithFeatureRegistry featureName="billingPlans">
              {feeAttempts.map(fee => (
                <Table.Row key={fee.id}>
                  <Table.Cell css={{ width: '30%', wordBreak: 'break-word' }}>{fee.owner}</Table.Cell>
                  <Table.Cell css={{ width: '35%', wordBreak: 'break-word' }}>
                    <Box css={{ display: 'flex', flexDirection: 'column' }}>
                      <Text>{fee.accountName}</Text>
                      <Text color="text.weak" variant="text50">
                        {fee.legalAccountType}
                      </Text>
                    </Box>
                  </Table.Cell>
                  <Table.Cell css={{ width: '35%', wordBreak: 'break-word' }}>
                    <Box css={{ display: 'flex', flexDirection: 'column' }}>
                      <Text>{formatMoney(toMoney(fee.amount))}</Text>
                      <Text color="text.weak" variant="text50">
                        {fee.description}
                      </Text>
                    </Box>
                  </Table.Cell>
                </Table.Row>
              ))}
            </IdempotencyProviderWithFeatureRegistry>
          </Table.Body>
        </Table>
      </Card.Content>
    </Card>
  );
};

export default ReviewFeesTable;
